import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import { View } from 'foundations-components/transitional/components/View';
import UISelect from 'UIComponents/input/UISelect';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorUIFieldSet from './EditorUIFieldSet';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionInputs = props => {
  const {
    condition,
    filterFamily,
    children,
    dataSeleniumInfo,
    disabled,
    header,
    objectTypeId,
    onConditionOperatorChange,
    onConditionValueChange,
    isRefinement = false,
    isRefinementEnabled = false
  } = props;
  const {
    getFieldLabelString
  } = useTranslationHelpers(filterFamily);
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition,
    disabled,
    filterFamily,
    onConditionOperatorChange,
    onConditionValueChange,
    isRefinement,
    isRefinementEnabled
  });
  return /*#__PURE__*/_jsxs(EditorUIFieldSet, {
    legend: getFieldLabelString(condition.field),
    isRefinement: isRefinement,
    children: [header, /*#__PURE__*/_jsx(UISelect, {
      "data-onboarding": "filter-condition-select-field",
      "data-selenium-info": dataSeleniumInfo,
      "data-selenium-test": "fr-filter-operator-select",
      "data-test-id": "fr-filter-operator-select",
      disabled: disableOperatorSelection,
      onSelectedOptionChange: onSelectedOptionChange,
      optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
        message: true,
        option: option
      }),
      options: operatorOptions,
      readOnly: operatorOptions.length === 1,
      value: condition.constructor.toString()
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
        condition: condition,
        disabled: disableValueInput,
        filterFamily: objectTypeId || filterFamily,
        onChange: onConditionValueChange
      })
    }), children, isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    })]
  });
};
export default EditorConditionInputs;